import { useState, useRef } from 'react';

export interface Effect {
  id: string;
  type: 'success' | 'error' | 'click' | 'hover' | 'achievement' | 'reward';
  message: string;
  duration: number;
}

export const useEffects = () => {
  const [effects, setEffects] = useState<Effect[]>([]);
  const timeoutRef = useRef<NodeJS.Timeout>();

  const addEffect = (type: Effect['type'], message: string, duration: number = 2000) => {
    const effect: Effect = {
      id: `effect-${Date.now()}-${Math.random()}`,
      type,
      message,
      duration
    };
    
    setEffects(prev => [...prev, effect]);
    
    // Remove effect after duration
    timeoutRef.current = setTimeout(() => {
      setEffects(prev => prev.filter(e => e.id !== effect.id));
    }, duration);
  };

  const clearEffects = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setEffects([]);
  };

  return {
    effects,
    addEffect,
    clearEffects
  };
};
